export const getDirectorySlug = (ref, name) =>
  ref +
  "-" +
  name
    .replace(/[^a-z0-9 ]/gi, "")
    .substring(0, 10)
    .trim()
    .replace(/\s+/g, "-");
